export default __webpack_public_path__ + "84f1ec90e5b7b265877d55ea4ebde61c.png";